<template>
  <div class="col-12 mb-primary">
    <div class="card card-with-shadow border-0 h-100">
      <app-overlay-loader v-if="preloader" />
      <div class="card-body">
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <app-breadcrumb
              page-title="Registro para Compañias"
              directory="Formulario"
              :icon="'trello'"
            />
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
              <a :href="backUrl" class="btn btn-primary">Volver</a>
            </div>
          </div>
        </div>

        <form
          ref="form"
          class="mb-0"
          data-url="/register/users/create"
          :class="{ 'loading-opacity': preloader }"
          enctype="multipart/form-data"
        >
          <fieldset class="form-group">
            <div class="card card-with-shadow border-0 mb-primary">
              <div class="card-header p-primary bg-transparent">
                <h5 class="card-title m-0">Información de la Compañia</h5>
              </div>
            </div>
            <app-note
              class="mb-2"
              note-type="note-red"
              :show-title="false"
              :notes="formNoteInstruction"
            />
            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >{{ $t("company_name") }}
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="text"
                    v-model="inputs.company_name"
                    :required="true"
                    :placeholder="$t('type_company_name')"
                  />
                  <small class="form-text text-muted"
                    >Si no aplica colocar N/A</small
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >{{ $t("social_reason") }}
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="text"
                    v-model="inputs.social_reason"
                    :required="true"
                    :placeholder="$t('type_social_reason')"
                  />
                </div>
              </div>
            </div>

            <div class="form-row">
            
              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >{{ $t("kind_society") }}
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    class="col-sm-8"
                    type="radio-buttons"
                    v-model="inputs.society_type"
                    :list="kindOfSocietyLists"
                    @input="onChageSector"
                    :required="true"
                  />
                  <!-- <app-input
                    class="col-sm-8"
                    type="radio-buttons"
                    @input="clicked"
                    v-model="inputs.society_type"
                    :list="kindOfSocietyLists"
                    :required="true"
                  /> -->
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >{{ $t("ruc") }}
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    id="sector1"
                    type="text"
                    v-if="inputs.society_type != 'other'"
                    v-model="inputs.ruc"
                    :min-length="0"
                    :max-length="20"
                    :required="true"
                    :placeholder="$t('type_ruc')"
                  />
                  <app-input
                    id="sector2"
                    type="text"
                    v-if="inputs.society_type == 'other'"
                    v-model="inputs.ruc"
                    :required="true"
                    :placeholder="$t('type_ruc')"
                  />
                  <!-- <app-input
                    type="text"
                    v-model="inputs.ruc"
                    :min-length="0"
                    :max-length="20"
                    :required="true"
                    v-on:keypress="isNumber"
                    @blur="handleBlur"
                    :placeholder="$t('type_ruc')"
                  /> -->
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >{{ $t("email") }}
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="email"
                    v-model="inputs.email"
                    @blur="handleBlurEmailCompany"
                    :required="true"
                    :placeholder="$t('type_email')"
                  />
                  <span
                    class="text-danger"
                    style="font-size: 18px !important"
                    v-if="msgEmail"
                  >
                    {{ msgEmail }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >{{ $t("company_address") }}
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="text"
                    v-model="inputs.company_address"
                    :required="true"
                    :placeholder="$t('type_company_address')"
                  />
                  <small class="form-text text-muted">{{
                    $t("address_note")
                  }}</small>
                </div>
              </div>
               <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("accreditation_area") }}</label>
                  <app-input
                    id="inputs_area_id"
                    type="select"
                    v-model="inputs.area_id"
                    :list="accreditationAreaList"
                    v-on:change="onChangeAccreditationArea"
                    :required="true"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("activity") }}</label>
                  <app-input
                    id="inputs_activity_id"
                    type="select"
                    v-model="inputs.activity_id"
                    :list="accreditationActivityLists"
                    :required="true"
                  />
                </div>
              </div> 
            </div>
            
           <div class="form-row">
              <div class="col-md-6">
                <div class="form-group mb-2 mb-md-0">
                  <label
                    >{{ $t("country") }}
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="search-select"
                    v-if="showSearch"
                    v-model="inputs.country_id"
                    @input="onChangeCountry"
                    :required="true"
                    :placeholder="$t('Ingrese País')"
                    :list="countryList"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-2 mb-md-0">
                  <div v-if="!showCity">
                    <label
                      >{{ $t("province") }}
                      <b class="text-danger" style="font-size: 18px !important"
                        >*</b
                      ></label
                    >
                    <app-input
                      type="select"
                      v-model="inputs.province_id"
                      v-on:change="onChangeProvince"
                      :required="true"
                      :placeholder="$t('type_company_address')"
                      :list="provinceList"
                    />
                  </div>
                  <div v-if="showCity">
                    <label
                      >{{ $t("Ciudad") }}
                      <b class="text-danger" style="font-size: 18px !important"
                        >*</b
                      ></label
                    >
                    <app-input
                      type="text"
                      v-model="inputs.city"
                      :required="showCity"
                      :placeholder="$t('Ingrese Ciudad')"
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group mb-2 mb-md-0">
                  <div v-if="!showCity">
                    <label
                      >{{ $t("canton") }}
                      <b class="text-danger" style="font-size: 18px !important"
                        >*</b
                      ></label
                    >
                    <app-input
                      type="select"
                      v-model="inputs.canton_id"
                      :required="true"
                      :list="cantonList"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >{{ $t("phone") }}
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="tel-input"
                    v-model="inputs.phone"
                    :required="true"
                    :placeholder="$t('type_phone')"
                  />
                  <small class="form-text text-muted">{{
                    $t("phone_note")
                  }}</small>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("Extensión") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.phone_extension"
                    :required="false"
                    :placeholder="$t('Extensión telefónica')"
                  />
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset class="form-group">
            <div class="card card-with-shadow border-0 mb-primary">
              <div class="card-header p-primary bg-transparent">
                <h5 class="card-title m-0">{{ $t("legal_rep") }}</h5>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >{{ $t("first_name") }}
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="text"
                    v-model="inputs.first_name"
                    :required="true"
                    :placeholder="$t('type_names')"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >{{ $t("last_name") }}
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="text"
                    v-model="inputs.last_name"
                    :required="true"
                    :placeholder="$t('type_lastname')"
                  />
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >{{ $t("Tipo de Identificación") }}
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="select"
                    v-model="inputs.taxid_legal_rep_type"
                    v-on:change="onChangeTaxIdType"
                    :required="true"
                    :list="taxidTypeLists"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >{{ $t("taxid_legal_rep") }}
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="text"
                    v-model="inputs.taxid_legal_rep"
                    :min-length="5"
                    :max-length="20"
                    v-on:keypress="isNumberw"
                    @blur="handleBlurCI"
                    :required="true"
                    :disabled="isDisabled"
                    :placeholder="$t('type_ci')"
                  />
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >{{ $t("email") }}
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                  <app-input
                    type="email"
                    v-model="inputs.email_legal_rep"
                    :required="true"
                    :placeholder="$t('type_email')"
                  />
                  <!-- <app-input
                    type="email"
                    v-model="inputs.email_legal_rep"
                    @blur="handleBlurEmail"
                    :required="true"
                    :placeholder="$t('type_email')"
                  /> -->
                  <span class="text-danger" v-if="msgEmailRep">
                    {{ msgEmailRep }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group"></div>
              </div>
            </div>
          </fieldset>

          <div class="card card-with-shadow border-0 mb-primary">
            <div class="card-header p-primary bg-transparent">
              <h5 class="card-title m-0">Adjuntos</h5>
            </div>
            <div class="card-body">
              <div class="form-group mb-primary row align-items-center">
                <label class="col-sm-2 mb-sm-0">
                  <label>RUC <b class="text-danger">*</b></label>
                </label>
                <div class="col-sm-8">
                  <app-input
                    type="file"
                    :label="rucFile"
                    v-model="inputs.attach_ruc"
                    v-on:change="fileChoosen"
                    :required="true"
                  />
                  <small class="form-text text-muted"
                    >Archivo .pdf del Registro Unico de Contribuyentes MAX
                    5MB</small
                  >
                </div>
              </div>

              <div class="form-group mb-primary row align-items-center">
                <label class="col-sm-2 mb-sm-0">
                  <label
                    >{{ $t("taxid_ci") }}
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                </label>
                <div class="col-sm-8">
                  <app-input
                    type="file"
                    :label="taxidFile"
                    v-model="inputs.attach_taxid"
                    v-on:change="fileChoosen"
                    :required="true"
                  />
                  <small class="form-text text-muted"
                    >Archivo .pdf del Cédula MAX 5MB</small
                  >
                </div>
              </div>

              <div class="form-group mb-primary row align-items-center">
                <label class="col-sm-2 mb-sm-0">
                  <label
                    >{{ $t("legal_rep_attach") }}
                    <b class="text-danger" style="font-size: 18px !important"
                      >*</b
                    ></label
                  >
                </label>
                <div class="col-sm-8">
                  <app-input
                    type="file"
                    :label="legalRepFile"
                    v-model="inputs.attach_legalrep"
                    v-on:change="fileChoosen"
                    :required="true"
                  />
                  <small class="form-text text-muted">{{
                    $t("legal_rep_attach_note")
                  }}</small>
                </div>
              </div>

              <div class="form-group mb-primary row align-items-center">
                <label class="col-sm-2 mb-sm-0"> </label>
                <div class="col-sm-8">
                  <app-note
                    class="pt-2 clearfix"
                    title="Nota Importante"
                    content-type="html"
                    note-type="note-info"
                    :notes="[
                      $t(
                        'SOLO APLICA PARA COMPAÑIAS QUE TENGAN CONVENIO CON EL SAE'
                      ),
                    ]"
                  />
                </div>
              </div>

              <div class="form-group mb-primary row align-items-center">
                <label class="col-sm-2 mb-sm-0">
                  <label>{{ $t("agreement") }}</label>
                </label>
                <div class="col-sm-8">
                  <app-input
                    type="file"
                    :label="agreementFile"
                    v-model="inputs.attach_agreement"
                    v-on:change="fileChoosen"
                  />
                  <small class="form-text text-muted">{{
                    $t("agreement_note")
                  }}</small>
                </div>
              </div>
            </div>
          </div>

          <div class="card card-with-shadow border-0 mb-primary">
            <div class="card-header p-primary bg-transparent">
              <h5 class="card-title m-0">{{ $t("data_access_system") }}</h5>
            </div>
            <app-overlay-loader v-if="preloader" />
            <div class="card-body">
              <div class="form-group row align-items-center">
                <label class="col-md-2 mb-md-0"
                  >{{ $t("username") }}
                  <b class="text-danger" style="font-size: 18px !important"
                    >*</b
                  ></label
                >
                <div class="col-md-8">
                  <app-input
                    type="text"
                    v-model="inputs.username"
                    :required="true"
                    :min-length="5"
                    :max-length="15"
                    @input="textToLower"
                    @blur="handleBlurUsername"
                    :placeholder="$t('type_username')"
                  />
                  <span
                    class="text-danger"
                    style="font-size: 15px !important"
                    v-if="msgUsername"
                  >
                    {{ msgUsername }}</span
                  >
                  <br />
                  <app-note
                    class="pt-2 clearfix"
                    :show-title="false"
                    content-type="html"
                    note-type="note-info"
                    :notes="[
                      $t(
                        'Debe de ser solo minúsculas, sin espacios, mínimo de 5 caracteres y máximo de 15 caracteres <b>Sugerencia:</b> primera letra del nombre del representante legal + apellido del representante legal. <b>Ejemplo:</b> usuariouno | pperez123'
                      ),
                    ]"
                  />
                </div>
              </div>

              <br />

              <div class="form-group row align-items-center">
                <label class="col-md-2 mb-md-0"
                  >{{ $t("password") }}
                  <b class="text-danger" style="font-size: 18px !important"
                    >*</b
                  ></label
                >
                <div class="col-md-8">
                  <div class="row">
                    <app-input
                      class="col-md-10"
                      :type="passwordFieldType"
                      :required="true"
                      :specialValidation="true"
                      :min-length="8"
                      :max-length="15"
                      v-model="inputs.password"
                      @input="textToLowerPass"
                      :placeholder="$t('type_password')"
                    />
                    <div
                      class="col-md-1 text-left align-middle"
                      :style="iconColor"
                    >
                      <div type="password" @click="switchVisibility">
                        <app-icon
                          style="margin-top: 10px"
                          :name="passwordIcon"
                        />
                      </div>
                    </div>
                  </div>
                  <span
                    class="text-danger"
                    style="font-size: 15px !important"
                    v-if="msgPassword"
                  >
                    {{ msgPassword }}</span
                  >
                  <br />

                  <app-note
                    class="mb-2"
                    note-type="note-warning"
                    :show-title="false"
                    :notes="[$t('password_hint_note')]"
                  />
                </div>
              </div>

              <br />

              <div class="form-group row align-items-center">
                <label class="col-md-2 mb-md-0"
                  >{{ $t("re_type_password") }}
                  <b class="text-danger" style="font-size: 18px !important"
                    >*</b
                  >
                </label>
                <div class="col-md-8">
                  <div class="row">
                    <app-input
                      :type="passwordRFieldType"
                      class="col-md-10"
                      v-model="inputs.confirm_password"
                      @input="textToLowerPassConfirm"
                      :required="true"
                      :min-length="8"
                      :max-length="15"
                      same-as="inputs_password"
                      :placeholder="$t('confirm_password')"
                    />
                    <div
                      class="col-md-1 text-left align-middle"
                      :style="iconRColor"
                    >
                      <div type="password" @click="switchRVisibility">
                        <app-icon
                          style="margin-top: 10px"
                          :name="passwordIcon"
                        />
                      </div>
                    </div>
                  </div>
                  <span
                    class="text-danger"
                    style="font-size: 15px !important"
                    v-if="msgPasswordConfirm"
                  >
                    {{ msgPasswordConfirm }}</span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="mt-5">
            <button
              type="submit"
              class="btn btn-primary mr-2"
              @click.prevent="submit"
            >
              {{ $t("submit") }}
            </button>
            <button
              type="submit"
              class="btn btn-secondary"
              @click.prevent="clear"
            >
              {{ $t("clear") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../apiUrl";
import Multiselect from "vue-multiselect";
import { axiosGet } from '../../../../../../../../resources/js/app/helpers/AxiosHelper';

export default {
  name: "RegisterUser",
  components: { Multiselect },
  mixins: [FormMixin],
  props: {
    backUrl: {
      type: String,
      default: "/",
    },
  },
  data() {
    return {
      url: "",
      rucFile: "Seleccionar Archivo",
      taxidFile: "Seleccionar Archivo",
      legalRepFile: "Seleccionar Archivo",
      agreementFile: "Seleccionar Archivo",
      selectedSocietyType: "",
      msgEmail: "",
      msgEmailRep: "",
      msgUsername: "",
      msgPassword: "",
      msgPasswordConfirm: "",
      passwordFieldType: "password",
      passwordIcon: "eye",
      iconColor: "color:#FBC02D",
      passwordRFieldType: "password",
      iconRColor: "color:#FBC02D",
      formRowInstruction: [this.$t("form_row_note")],
      formNoteInstruction: [
        this.$t("Todos los campos con un (*) son obligatorios."),
      ],
      preloader: false,
      isDisabled: true,
      showCity: false,
      showSearch: false,
      inputs: {},
      taxidTypeLists: [
        { id: "", value: "Seleccione" },
        { id: "ci", value: "Cédula de Identidad" },
        { id: "other", value: "Pasaporte" },
      ],
      kindOfSocietyLists: [
        { id: "private", value: "Sector Privada" },
        { id: "public", value: "Sector Pública" },
        { id: "other", value: "Otro" },
      ],
      countryLists: [],
      countryList: [],
      provinceLists: [],
      provinceList: [{ id: "", value: "Seleccione Provincia" }],
      cantonLists: [],
      cantonList: [{ id: "", value: "Seleccione Canton" }],
      accreditationAreaList: [],
      accreditationActivityList:[],
      accreditationActivityLists:[],
    };
  },
  watch: {
    "inputs.email": function () {
      let email = this.inputs.email;
      this.validateEmailInput(email, true);
    },
    "inputs.email_legal_rep": function () {
      let email = this.inputs.email_legal_rep;
      this.validateEmailInput(email, false);
    },
  },
  created() {
    this.data(); 
    // let uri = `//options`;
    //   axiosGet(uri).then((response) => {
    //     this.accreditationAreaList = [
    //       { id: "", value: "Selecciona una opción" },
    //       ...response.data.accreditationAreas,
    //     ];

    //     this.accreditationActivityList = [
    //       { id: "", value: "Selecciona una opción" },
    //       ...response.data.accreditationActivities,
    //     ];
    //     })
    let uraa = `//activitiesMix`;
      axiosGet(uraa).then((response) => {
        this.accreditationAreaList = [
          { id: "", value: "Selecciona una opción" },
          ...response.data.accArea,
        ];

        this.accreditationActivityList = [
          { id: "", value: "Selecciona una opción" },
          ...response.data.accActivitie,
        ];

      });
  },
  methods: {
    textToLower(val) {
      this.inputs.username = val.toLowerCase().trim();
      if(this.inputs.username.length < 5){
        this.msgUsername = "Nombre de Usuario debe de ser mínimo de 5 caracteres";
      }else{
        this.msgUsername = "";
      }
    },
    textToLowerPass(val) {
      this.inputs.password = val.trim();
      this.inputs.password = this.inputs.password.replace("-", "");
      if(this.inputs.password.length < 8){
        this.msgPassword = "Contraseña debe de ser mínimo de 8 caracteres";
      }else{
        this.msgPassword = "";
      }
    },
    textToLowerPassConfirm(val) {
      this.inputs.confirm_password = val.trim();
      this.inputs.confirm_password = this.inputs.confirm_password.replace("-", "");
      if(this.inputs.confirm_password.length < 8){
        this.msgPasswordConfirm = "Confirmación de Contraseña debe de ser mínimo de 8 caracteres";
      }else{
        this.msgPasswordConfirm = "";
      }
    },
    handleBlurUsername(e) {
      this.validateUsername();
    },
    handleBlurCI(e) {
      if (this.inputs.taxid_legal_rep_type === "ci") {
        this.validateTaxid("ci");
      }
    },
    handleBlur(e) {
      if (e.target.value.length === 13) {
        if (this.inputs.society_type) {
          this.validateTaxid("ruc");
        }
      }
    },
    clicked(event) {
      if (this.inputs.society_type !== "other") {
        if (this.inputs.ruc && this.inputs.ruc.length === 13) {
          this.validateTaxid("ruc");
        } else {
          this.inputs.ruc = null;
          this.$toastr.e("El campo RUC es obligatorio y debe tener 13 digitos");
        }
      }
    },
    // afterJsValidationFail() {
    //   this.$toastr.e(
    //     "Algunos campos del formulario tienen errores o no han sido completados."
    //   );
    // },
    switchVisibility() {
      if (this.passwordFieldType == "password") {
        this.iconColor = "color:#4466F2";
        this.passwordFieldType = "text";
        this.passwordIcon = "eye-off";
      } else if (this.passwordFieldType == "text") {
        this.passwordFieldType = "password";
        this.iconColor = "color:#FBC02D";
        this.passwordIcon = "eye";
      }
    },
    switchRVisibility() {
      if (this.passwordRFieldType == "password") {
        this.iconRColor = "color:#4466F2";
        this.passwordRFieldType = "text";
      } else if (this.passwordRFieldType == "text") {
        this.passwordRFieldType = "password";
        this.iconRColor = "color:#FBC02D";
      }
    },
    onChangeAccreditationArea() {
      this.accreditationActivityLists = [
        { id: "", value: this.$t("select_option") },
        ...this.accreditationActivityList.filter((item) => {
          return item.parent == this.inputs.area_id;
        }),
      ];
    },
    validateTaxid(type) {
      this.preloader = true;
      let url;
      if (type === "ruc") {
        url = `${actions.USERS_REGISTER}/validate/${this.inputs.ruc}/${this.inputs.society_type}`;
      } else if (type === "ci") {
        url = `${actions.USERS_REGISTER}/validate/${this.inputs.taxid_legal_rep}/${type}`;
      }
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            if (!response.data.validate) {
              if (type === "ruc") {
                this.inputs.ruc = null;
                this.inputs.society_type = null;
              } else if (type === "ci") {
                this.inputs.taxid_legal_rep = null;
              }
              this.$toastr.e(response.data.message);
            }
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    validateUsername() {
      this.preloader = true;
      let url = `${actions.USERS_REGISTER}/validateUsername/${this.inputs.username}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            if (!response.data.validate) {
              this.inputs.username = null;
              this.$toastr.e(response.data.message);
            }
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    handleBlurEmailCompany() {
      this.validateEmailCompany();
    },
    validateEmailCompany() {
      this.preloader = true;
      let url = `${actions.USERS_REGISTER}/validateEmailCompany/${this.inputs.email}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            if (!response.data.validate) {
              this.inputs.email = null;
              this.$toastr.e(response.data.message);
            }
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    handleBlurEmail(e) {
      this.validateEmail();
    },
    validateEmail() {
      this.preloader = true;
      let url = `${actions.USERS_REGISTER}/validateEmail/${this.inputs.email_legal_rep}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            if (!response.data.validate) {
              this.inputs.email_legal_rep = null;
              this.$toastr.e(response.data.message);
            }
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    fileChoosen(event) {
      if (event.target.files[0].type === "application/pdf") {
        if (event.target.files[0].size < 5111775) {
          if (event.srcElement.id === "inputs_attach_ruc") {
            this.rucFile = event.target.files[0].name;
          }

          if (event.srcElement.id === "inputs_attach_taxid") {
            this.taxidFile = event.target.files[0].name;
          }

          if (event.srcElement.id === "inputs_attach_legalrep") {
            this.legalRepFile = event.target.files[0].name;
          }

          if (event.srcElement.id === "inputs_attach_agreement") {
            this.agreementFile = event.target.files[0].name;
          }
        } else {
          this.$toastr.e("El archivo PDF no debe exceder los 5MB.");
        }
      } else {
        this.$toastr.e("Solo permitidos archivos .pdf");
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberw: function (evt) {
      if (this.inputs.taxid_legal_rep_type === "ci") {
        evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
      }
    },
    beforeSubmit() {
      this.preloader = true;
    },
    async submit() {
      if (this.passwordFieldType == "text") this.switchVisibility();
      if (this.passwordRFieldType == "text") this.switchRVisibility();
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      await this.save(formData);
    },
    afterSuccess(res) {
      window.location = res.data;
    },
    afterFinalResponse() {
      this.preloader = false;
    },
    afterError(res) {
      if (res.data.errors.username) {
        this.$toastr.e("El nombre de usuario ya esta en uso");
      } else {
        this.$toastr.e("Los datos proporcionados no son válidos.");
      }
    },
    clear() {
      this.inputs = {
        isSubmit: false,
      };
      this.rucFile = "Seleccionar Archivo";
      this.taxidFile = "Seleccionar Archivo";
      this.legalRepFile = "Seleccionar Archivo";
      this.agreementFile = "Seleccionar Archivo";
    },
    data() {
      this.preloader = true;
      let url = `${actions.COMMON_POLITICAL_DIVISION}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            this.countryLists = response.data.countries;
            this.countryList = [
              ...this.countryLists.filter((item) => {
                return item;
              }),
            ];
            this.provinceLists = response.data.provinces;
            this.cantonLists = response.data.cantons;
            this.showSearch = true;
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    onChangeCountry() {
      this.provinceList = [
        { id: "", value: "Seleccione Provincia" },
        ...this.provinceLists.filter((item) => {
          return item.parent == this.inputs.country_id;
        }),
      ];
      if (this.provinceList.length === 1) {
        this.showCity = true;
        this.inputs.province_id = null;
        this.inputs.canton_id = null;
      } else {
        this.showCity = false;
        this.inputs.city = null;
        this.inputs.province_id = null;
        this.inputs.canton_id = null;
      }
    },
    onChangeProvince() {
      this.cantonList = [
        { id: "", value: "Seleccione Canton" },
        ...this.cantonLists.filter((item) => {
          return item.parent == this.inputs.province_id;
        }),
      ];
    },
    onChangeTaxIdType() {
      if (this.inputs.taxid_legal_rep_type) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    validateEmailInput(value, type) {
      if (/\S+@\S+\.\S+/.test(value)) {
        if (type) {
          this.msgEmail = "";
        } else {
          this.msgEmailRep = "";
        }
      } else {
        if (type) {
          this.msgEmail = "Dirección de correo electrónico no válida";
        } else {
          this.msgEmailRep = "Dirección de correo electrónico no válida";
        }
      }
    },
    onChageSector() {
      this.inputs.ruc = "";
    }
  },
};
</script>
